import { render, staticRenderFns } from "./OrganizationDetailsEditModal.vue?vue&type=template&id=8b343382&scoped=true&"
import script from "./OrganizationDetailsEditModal.vue?vue&type=script&lang=ts&"
export * from "./OrganizationDetailsEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationDetailsEditModal.vue?vue&type=style&index=0&id=8b343382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b343382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b343382')) {
      api.createRecord('8b343382', component.options)
    } else {
      api.reload('8b343382', component.options)
    }
    module.hot.accept("./OrganizationDetailsEditModal.vue?vue&type=template&id=8b343382&scoped=true&", function () {
      api.rerender('8b343382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/OrganizationDetailsEditModal.vue"
export default component.exports